// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"0ea70a4e","453":"c0ed4291"}[chunkId] + ".chunk.js";
};